
import axios from 'axios';

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
/**
 * Secure Pharmacy Service
 * Uses backend API endpoints instead of direct Firestore access
 */

// Get all pharmacies
export async function getAllPharmacies(facilityId) {
  try {
    if (!facilityId) {
      throw new Error('Facility ID is required');
    }
    
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/pharmacies?facilityId=${facilityId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get pharmacies');
  } catch (error) {
    console.error('Error getting pharmacies:', error);
    throw error;
  }
}

// Create a new pharmacy
export async function createPharmacy(pharmacyData) {
  try {
    if (!pharmacyData.facilityId) {
      throw new Error('Facility ID is required');
    }
    
    const token = await getAuthToken();
    const response = await axios.post(`${API_BASE}/clinical/pharmacies`, pharmacyData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 201) {
      return response.data;
    }

    throw new Error('Failed to create pharmacy');
  } catch (error) {
    console.error('Error creating pharmacy:', error);
    throw error;
  }
}

// Update an existing pharmacy
export async function updatePharmacy(pharmacyId, updateData) {
  try {
    const token = await getAuthToken();
    const response = await axios.put(`${API_BASE}/clinical/pharmacies/${pharmacyId}`, updateData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to update pharmacy');
  } catch (error) {
    console.error('Error updating pharmacy:', error);
    throw error;
  }
}

// Get pharmacy by ID
export async function getPharmacyById(pharmacyId) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/pharmacies/${pharmacyId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get pharmacy');
  } catch (error) {
    console.error('Error getting pharmacy:', error);
    throw error;
  }
}

// Delete a pharmacy
export async function deletePharmacy(pharmacyId) {
  try {
    const token = await getAuthToken();
    const response = await axios.delete(`${API_BASE}/clinical/pharmacies/${pharmacyId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to delete pharmacy');
  } catch (error) {
    console.error('Error deleting pharmacy:', error);
    throw error;
  }
}
